<section>
  <app-list-view
    [columnDefinition]="columnDefinitions"
    [contextMenuDefinition]="contextMenuDefinitions"
    [itemsSource]="items"
    [preferencesKey]="'rent.lease-agreement-document-manager.list'"
    [contextId]="contextId"
    (rowClick)="onRowClicked($event)"
  >
  </app-list-view>
</section>
